import { styled } from "@mui/material";
import { Realm } from "api/types";
import { realms } from "./realms";
import { RealmTag } from "./RealmTag";

const PREFIX = "RealmTagList";

const classes = {
	chip: `${PREFIX}-chip`,
};

const Root = styled("div")(({ theme }) => ({
	[`& .${classes.chip}`]: {
		marginRight: theme.spacing(1),
		marginBottom: theme.spacing(1),
		padding: theme.spacing(1),
		backgroundColor: theme.palette.grey[200],
	},
}));

export interface RealmTagListProps {
	selected: Realm[];
	handler: (realms: Realm[]) => void;
}

export const RealmTagList = (props: RealmTagListProps): JSX.Element => {
	const { selected, handler } = props;

	const handleClick = (selectedTag: Realm): void => {
		selected.includes(selectedTag)
			? handler(selected.filter((tag) => tag !== selectedTag))
			: handler([...selected, selectedTag]);
	};

	const handleDelete = (selectedTag: Realm): void => {
		if (selected.includes(selectedTag)) {
			handler(selected.filter((tag) => tag !== selectedTag));
		}
	};

	return (
		<Root>
			{realms.map((realm) => (
				<RealmTag
					key={realm.name}
					selected={selected.includes(realm.name)}
					name={realm.name}
					onClick={handleClick}
					onDelete={handleDelete}
				/>
			))}
		</Root>
	);
};
